var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAjax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%",
      display: "block",
      shapeRendering: "auto"
    },
    width: "171px",
    height: "171px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0;51.42857142857143",
    keyTimes: "0;1",
    dur: "0.5555555555555556s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.682013824881775 -4.5 L50.68201382488178 -4.5 L50.68201382488178 4.5 L31.682013824881775 4.5 A32 32 0 0 1 23.27165419326733 21.964291727915633 L23.27165419326733 21.964291727915633 L35.117960428583274 36.8190898948082 L28.081477086371002 42.4304981115368 L16.235170851055063 27.575699944644235 A32 32 0 0 1 -2.6627357011113486 31.889023794811077 L-2.6627357011113486 31.889023794811077 L-6.890633446281321 50.41265412626572 L-15.664984655917735 48.409965720658896 L-11.437086910747762 29.88633538920425 A32 32 0 0 1 -26.592031302643512 17.800670526674764 L-26.592031302643512 17.800670526674764 L-43.71043979278947 26.04446156990837 L-47.6153934448475 17.935741758786598 L-30.496984954701535 9.691950715552991 A32 32 0 0 1 -30.49698495470154 -9.691950715552984 L-30.49698495470154 -9.691950715552984 L-47.6153934448475 -17.935741758786584 L-43.71043979278948 -26.044461569908357 L-26.592031302643516 -17.800670526674757 A32 32 0 0 1 -11.43708691074777 -29.886335389204245 L-11.43708691074777 -29.886335389204245 L-15.664984655917745 -48.40996572065889 L-6.890633446281333 -50.41265412626572 L-2.6627357011113566 -31.889023794811077 A32 32 0 0 1 16.235170851055056 -27.57569994464424 L16.235170851055056 -27.57569994464424 L28.08147708637099 -42.43049811153681 L35.11796042858326 -36.81908989480821 L23.271654193267324 -21.964291727915636 A32 32 0 0 1 31.682013824881775 -4.500000000000008 M0 -15A15 15 0 1 0 0 15 A15 15 0 1 0 0 -15",
    fill: "#b46f39"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjax);
export default __webpack_public_path__ + "static/media/ajax.b52259f2d2056476acb165566d3992e6.svg";
export { ForwardRef as ReactComponent };